import React, { Component } from 'react';

class FallbackImg extends Component {
	constructor(props) {
		super(props);
		this.state = { is_fallback: false };
	}

	render() {
		var other_attributes = {};
		for (var k in this.props) if (k !== "src" && k !== "fallbackSrc" && k !== "alt") other_attributes[k] = this.props[k];
		const alt = this.props.alt || ""; // react complains if I don't set this explicitly
		if (!this.state.is_fallback) {
			const fallback = () => { this.setState({ is_fallback: true }); };
			return <img alt={alt} src={this.props.src} onError={fallback} {...other_attributes}/>
		} else {
			delete other_attributes.srcSet;
			return <img alt={alt} src={this.props.fallbackSrc} {...other_attributes}/>
		}
	}
}

export default FallbackImg;




// WEBPACK FOOTER //
// ./src/c/FallbackImg.js